export default __webpack_public_path__ + "static/media/28_4_3.c7c2fca4.png";